import { mapActions, mapGetters } from 'vuex'
import * as actions from "../../../../store/modules/actions"
import * as getters from "../../../../store/modules/getters"

export default {
    props: {},
    data() {
        return {
            loading: false,
            showNewTeamModal: false,
            showMenuOption: false,
            currentIdx: null
        }
    },
    computed: {
        ...mapGetters({
            itMembers: getters.IT_TEAM
        })
    },
    methods: {
        ...mapActions({
            createNewMember: actions.CREATE_IT_MEMBER,
            fetchNewMembers: actions.FETCH_IT_TEAM,
            deleteITMember: actions.DELETE_IT_MEMBER,
            resendInvite: actions.RESEND_IT_INVITE
        }),
        async sendInvite(data): Promise<void> {
            try{
                this.loading = true
                const payload = [data]
                await this.createNewMember(payload);
                this.$message.info('Invite Sent successfuly');

            } catch (err) {
                this.$message.error('An error occured.');
            }
            finally{
                this.showNewTeamModal = false
                this.loading = false
            }

        },
        toggleNewTeamModal(status: Boolean){
            this.showNewTeamModal = status
        },
        onShowMenuOption(id){
            this.currentIdx = id
        },
        async onResendInvite(id: String){
            try{
                await this.resendInvite(id);
                this.$message.info('Invite Resent successfuly');
            } catch (err) {
                this.$message.error('An error occured.');
            }
        },
        async onRemoveUser(memberEmail: String){
            try{
                const payload = {
                    email: memberEmail
                }
                await this.deleteITMember(payload);
                this.$message.info('User Removed successfuly');
            } catch (err) {
                this.$message.error('An error occured.');
            }

        }
    },
    created() {
        this.fetchNewMembers()
    }
}